import { IKeyValuePair } from './../../../models/KeyValuePair';
import { NavParams } from '@ionic/angular';
import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'app-show-observation',
	templateUrl: './show-observation.component.html',
	styleUrls: ['./show-observation.component.scss'],
})
export class ShowObservationComponent implements OnInit {

	public Data: IKeyValuePair[];
	constructor(
		private navParams: NavParams
	) {

		this.Data = this.navParams.get('data') || [];
	}

	ngOnInit() { }

}
